import React from 'react';

const LeftButton = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="white" />
    <g clipPath="url(#clip0_616_8880)">
      <path
        d="M19.3334 9.99999C19.256 9.92238 19.1641 9.86081 19.0628 9.8188C18.9616 9.77679 18.853 9.75517 18.7434 9.75517C18.6338 9.75517 18.5253 9.77679 18.424 9.8188C18.3228 9.86081 18.2308 9.92238 18.1534 9.99999L12.6134 15.5333C12.4913 15.6579 12.4229 15.8255 12.4229 16C12.4229 16.1745 12.4913 16.342 12.6134 16.4667L18.1534 22C18.2256 22.0959 18.3175 22.1753 18.4229 22.2328C18.5283 22.2902 18.6448 22.3244 18.7646 22.333C18.8843 22.3416 19.0045 22.3244 19.1171 22.2827C19.2297 22.2409 19.332 22.1755 19.4171 22.0908C19.5022 22.0062 19.5682 21.9042 19.6106 21.7919C19.6531 21.6796 19.6709 21.5595 19.663 21.4397C19.655 21.3199 19.6215 21.2032 19.5647 21.0974C19.5078 20.9917 19.429 20.8994 19.3334 20.8267L14.5068 16L19.3334 11.16C19.4841 11.0045 19.5684 10.7965 19.5684 10.58C19.5684 10.3635 19.4841 10.1555 19.3334 9.99999Z"
        fill="#6B6C7B"
      />
    </g>
    <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#D5D5D9" />
    <defs>
      <clipPath id="clip0_616_8880">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export default LeftButton;
